import { defineStore } from 'pinia';

// Modal "Baixe o APP e resgate o seu bônus" (Figma node 19376:45204) — irmão
// do `app-download`, e não um estado dele: o cartaz genérico (ENG-495) segue
// atendendo o menu lateral e o deep-link `?open=modal-aplicativo`, enquanto
// este é o convite específico do bônus resgatável só pelo app (ENG-799).
//
// Store própria, e não um parâmetro do `open()` do outro, porque os dois têm
// composição diferente e o de lá é usado em outro lugar: assim nada do
// caminho existente muda de comportamento.
export const useAppDownloadBonusStore = defineStore(
  'app-download-bonus',
  () => {
    const isOpen = ref(false);

    function open() {
      isOpen.value = true;
    }

    function close() {
      isOpen.value = false;
    }

    return { isOpen, open, close };
  },
);
